module.exports = __webpack_public_path__ + "img/payment-method-mpo.57898b75.png";